/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PseudonymSuggestionChooseAnotherDateAliases {
  BUTTON_CHOOSE_ANOTHER_DATE_CANCEL = 'button-choose-another-date-cancel',
  BUTTON_CHOOSE_ANOTHER_DATE_SAVE = 'button-choose-another-date-save',
  CONTEXTUAL_BAR_SUGGESTION_CHOOSE_ANOTHER_DATE = 'contextual-bar-suggestion-choose-another-date',
  DATE_PICKER_RANGE = 'date-picker-range',
  FIELD_AVAILABLE_PERIOD = 'field-available-period',
  FIELD_AVAILABLE_TIME = 'field-available-time',
  FORM_SUGGESTION_CHOOSE_ANOTHER_DATE = 'form-suggestion-choose-another-date',
  GLOBAL_ACTIONS_CHOOSE_ANOTHER_DATE = 'global-actions-choose-another-date',
  LAYOUT_SUGGESTION_CHOOSE_ANOTHER_DATE = 'layout-suggestion-choose-another-date',
  PANEL_SUGGESTION_CHOOSE_ANOTHER_DATE = 'panel-suggestion-choose-another-date',
  TIME_FIELD_AVAILABLE_TIME = 'time-field-available-time',
}
export { PseudonymSuggestionChooseAnotherDateAliases };
